import { US_STATES, CANADA_PROVINCES } from "../../../utils/States";
import { normalizeCountryCode } from "../../../utils/Countries";
import {
  normalizeCity,
  normalizeConsultantIndustry,
  normalizeCountry as normalizeCountryLabel,
  normalizeState,
} from "../../../utils/filterNormalization";
export { downloadBlobFile } from "../../../utils/download";

const STATE_NAME_TO_CODE = Object.fromEntries(
  [...US_STATES, ...CANADA_PROVINCES].map(({ code, name }) => [name, code]),
);

const normalizeCountry = (value) =>
  normalizeCountryCode(normalizeCountryLabel(value));

const normalizeStateCode = (value) => {
  const normalizedState = normalizeState(value);
  return STATE_NAME_TO_CODE[normalizedState] || "";
};

const parseIndustries = (value) => {
  if (!value) return [];

  return value
    .split(",")
    .map((industry) => normalizeConsultantIndustry(industry))
    .filter(Boolean);
};

const cleanIndustryLabel = (value) => {
  if (value == null) return "";
  return String(value).trim().replace(/\s+/g, " ");
};

export const getConsultantIndustries = (consultant) => {
  if (Array.isArray(consultant?.industries_list) && consultant.industries_list.length) {
    return [...new Set(
      consultant.industries_list.map(cleanIndustryLabel).filter(Boolean),
    )];
  }

  if (consultant?.normalized_industry) {
    const normalized = cleanIndustryLabel(consultant.normalized_industry);
    return normalized ? [normalized] : [];
  }

  return [...new Set(parseIndustries(consultant?.industries))];
};

const getConsultantDisplayState = (consultant) => {
  if (!consultant) return "";

  if (consultant.country_code === "US" && consultant.state_code) {
    return consultant.state_code;
  }

  return consultant.state || "";
};

export const getConsultantDisplayLocation = (consultant) =>
  [consultant?.city, getConsultantDisplayState(consultant), consultant?.country]
    .filter(Boolean)
    .join(", ");

export const normalizeSiteConsultant = (consultant) => ({
  ...consultant,
  city: normalizeCity(consultant.city),
  state: normalizeState(consultant.state),
  country: normalizeCountryLabel(consultant.country),
  country_code: normalizeCountry(consultant.country),
  state_code: normalizeStateCode(consultant.state),
  industries_list: getConsultantIndustries(consultant),
  get location() {
    return getConsultantDisplayLocation(this);
  },
  get display_state() {
    return getConsultantDisplayState(this);
  },
});
